module.exports = __webpack_public_path__ + "style/img/gonzhonghao.89734763.jpg";